import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';
import ReactAudioPlayer from 'react-audio-player';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { UiHelper } from '../common/helpers/UiHelper';

import { Fade, Slide } from '@material-ui/core';
import { AppHelper } from '../helpers/AppHelper';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class AudioPreviewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <ReactAudioPlayer
            src={this.props.audio}
            autoPlay
            controls
          />
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 200,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    maxWidth: 400,
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/AudioPreviewDialog.js